export var SalesType;
(function (SalesType) {
    SalesType["UNKNOWN"] = "UNKNOWN";
    SalesType["SEASONAL"] = "SEASONAL";
    SalesType["SEASONAL_EXTENDED"] = "SEASONAL_EXTENDED";
    SalesType["PERSONAL"] = "PERSONAL";
    SalesType["CUSTOM"] = "CUSTOM";
})(SalesType || (SalesType = {}));
export var Brand;
(function (Brand) {
    Brand["UNKNOWN"] = "UNKNOWN";
    Brand["WIX"] = "WIX";
    Brand["EDITORX"] = "EDITORX";
    Brand["DAYFUL"] = "DAYFUL";
})(Brand || (Brand = {}));
//# sourceMappingURL=types.impl.js.map